import { ErrorHandler, inject, Injectable } from '@angular/core';
import { NotificationDialComponent } from '../utils/dialogues/notification-dial/notification-dial.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly dialogRef = inject(MatDialog);
  isDialogOpen = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    console.error('Global error:', error.cause ?? error);
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;

      const ref = this.dialogRef.open(NotificationDialComponent, {
        data: {
          title: 'An unexpected error occurred!',
          message:
            error?.cause?.error?.message ??
            error?.error?.message ??
            error?.message ??
            error?.error ??
            error,
        },
      });
      ref.afterClosed().subscribe(() => {
        this.isDialogOpen = false;
      });
    }
  }
}
